import {omit} from 'underscore';

import Coordinate from 'common/types/Coordinate';

export default class VehiclePosition {
  /* eslint-disable camelcase */
  constructor(
    {
      altitude = null,
      device_id = null,
      driver = null,
      heading = null,
      horizontal_accuracy = null,
      position = null,
      speed = null,
      vehicle_id = null,
      vertical_accuracy = null,
      timestamp = null,
      enabled = null,
      eligible = null,
      stale = null,
    },
  ) {
    this.altitude = altitude;
    this.deviceId = device_id;
    this.driver = driver ? {firstName: driver.first_name, lastName: driver.last_name} : null;
    this.heading = heading;
    this.horizontalAccuracy = horizontal_accuracy;
    this.position = position ? new Coordinate(position.latitude, position.longitude) : null;
    this.speed = speed;
    this.vehicleId = vehicle_id;
    this.verticalAccuracy = vertical_accuracy;
    this.timestamp = timestamp;
    this.enabled = enabled;
    this.eligible = eligible;
    this.stale = stale;
  }
  /* eslint-enable camelcase */

  clone() {
    return new VehiclePosition(this.serialize());
  }

  serialize() {
    return omit(
      {
        altitude: this.altitude,
        device_id: this.deviceId,
        driver: this.driver
          ? {first_name: this.driver.firstName, last_name: this.driver.lastName}
          : null,
        heading: this.heading,
        horizontal_accuracy: this.horizontalAccuracy,
        position: this.position
          ? {latitude: this.position.lat, longitude: this.position.lng}
          : null,
        speed: this.speed,
        vehicle_id: this.vehicleId,
        vertical_accuracy: this.verticalAccuracy,
        timestamp: this.timestamp,
        enabled: this.enabled,
        eligible: this.eligible,
        stale: this.stale,
      },
      value => value === null,
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/types/VehiclePosition.js